// @flow

import * as React from 'react';
import styled from '@emotion/styled';

import OddsProvider from 'app/images/onesport/oddsProvider.png';

type Props = {
  className?: string
};

const defaultProps = {
  className: undefined
};

const Img = styled.img({
  width: 'auto',
  height: 42
});

const OddsProvidedBy: React.FC<Props> = ({ className }: Props) => (
  <Img className={className} src={OddsProvider} alt="" />
);

OddsProvidedBy.defaultProps = defaultProps;

export default OddsProvidedBy;
